import { OrganType } from '@/api/apis/case';
import { RoutePlanType } from '@/types/route';
import { BenchmarkResourcesList } from './BenchmarkResourcesList';
import { RouteItemShell } from './RouteItemShell';

type BenchmarkRouteItemProps = {
  routePlan: RoutePlanType;
  organType: OrganType;
};

export const BenchmarkRouteItem = ({ routePlan, organType }: BenchmarkRouteItemProps) => (
  <RouteItemShell
    routePlan={routePlan}
    organType={organType}
    isBenchmark
    flightTimeBadges={
      <span className="w-max block py-0.5 px-1 bg-white rounded-sm text-s-sb text-base-5">benchmark</span>
    }
  >
    <BenchmarkResourcesList
      locations={routePlan.locations}
      routePlanSegments={routePlan.segments}
      organType={organType}
    />
  </RouteItemShell>
);
